import React from "react";
import { useParams } from "react-router";
import CreatePartnerContainer from "../../containers/partners/CreatePartners";

const CreatePartnerPage = () => {
  const { id } = useParams();
  return id ? (
    <CreatePartnerContainer partnerId={id} />
  ) : (
    <CreatePartnerContainer />
  );
};

export default CreatePartnerPage;
